/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as LogsRouteImport } from './routes/logs'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DevRouteImport } from './routes/dev'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as BugReportsRouteImport } from './routes/bug-reports'
import { Route as AppsRouteImport } from './routes/apps'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppsIndexRouteImport } from './routes/apps.index'
import { Route as AppsAppIdRouteImport } from './routes/apps.$appId'
import { Route as AppsAppIdIndexRouteImport } from './routes/apps.$appId.index'
import { Route as AppsAppIdVillagesRouteImport } from './routes/apps.$appId.villages'
import { Route as AppsAppIdUsersRouteImport } from './routes/apps.$appId.users'
import { Route as AppsAppIdProductsRouteImport } from './routes/apps.$appId.products'
import { Route as AppsAppIdPaymentsRouteImport } from './routes/apps.$appId.payments'
import { Route as AppsAppIdOrdersRouteImport } from './routes/apps.$appId.orders'
import { Route as AppsAppIdLogsRouteImport } from './routes/apps.$appId.logs'
import { Route as AppsAppIdErrorsRouteImport } from './routes/apps.$appId.errors'
import { Route as AppsAppIdVillagesIndexRouteImport } from './routes/apps.$appId.villages.index'
import { Route as AppsAppIdUsersIndexRouteImport } from './routes/apps.$appId.users.index'
import { Route as AppsAppIdVillagesVillageIdRouteImport } from './routes/apps.$appId.villages.$villageId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const LogsRoute = LogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BugReportsRoute = BugReportsRouteImport.update({
  id: '/bug-reports',
  path: '/bug-reports',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsRoute = AppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsIndexRoute = AppsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppsRoute,
} as any)
const AppsAppIdRoute = AppsAppIdRouteImport.update({
  id: '/$appId',
  path: '/$appId',
  getParentRoute: () => AppsRoute,
} as any)
const AppsAppIdIndexRoute = AppsAppIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppsAppIdRoute,
} as any)
const AppsAppIdVillagesRoute = AppsAppIdVillagesRouteImport.update({
  id: '/villages',
  path: '/villages',
  getParentRoute: () => AppsAppIdRoute,
} as any)
const AppsAppIdUsersRoute = AppsAppIdUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppsAppIdRoute,
} as any)
const AppsAppIdProductsRoute = AppsAppIdProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppsAppIdRoute,
} as any)
const AppsAppIdPaymentsRoute = AppsAppIdPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AppsAppIdRoute,
} as any)
const AppsAppIdOrdersRoute = AppsAppIdOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppsAppIdRoute,
} as any)
const AppsAppIdLogsRoute = AppsAppIdLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AppsAppIdRoute,
} as any)
const AppsAppIdErrorsRoute = AppsAppIdErrorsRouteImport.update({
  id: '/errors',
  path: '/errors',
  getParentRoute: () => AppsAppIdRoute,
} as any)
const AppsAppIdVillagesIndexRoute = AppsAppIdVillagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppsAppIdVillagesRoute,
} as any)
const AppsAppIdUsersIndexRoute = AppsAppIdUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppsAppIdUsersRoute,
} as any)
const AppsAppIdVillagesVillageIdRoute =
  AppsAppIdVillagesVillageIdRouteImport.update({
    id: '/$villageId',
    path: '/$villageId',
    getParentRoute: () => AppsAppIdVillagesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/apps': typeof AppsRouteWithChildren
  '/bug-reports': typeof BugReportsRoute
  '/dashboard': typeof DashboardRoute
  '/dev': typeof DevRoute
  '/login': typeof LoginRoute
  '/logs': typeof LogsRoute
  '/profile': typeof ProfileRoute
  '/users': typeof UsersRoute
  '/apps/$appId': typeof AppsAppIdRouteWithChildren
  '/apps/': typeof AppsIndexRoute
  '/apps/$appId/errors': typeof AppsAppIdErrorsRoute
  '/apps/$appId/logs': typeof AppsAppIdLogsRoute
  '/apps/$appId/orders': typeof AppsAppIdOrdersRoute
  '/apps/$appId/payments': typeof AppsAppIdPaymentsRoute
  '/apps/$appId/products': typeof AppsAppIdProductsRoute
  '/apps/$appId/users': typeof AppsAppIdUsersRouteWithChildren
  '/apps/$appId/villages': typeof AppsAppIdVillagesRouteWithChildren
  '/apps/$appId/': typeof AppsAppIdIndexRoute
  '/apps/$appId/villages/$villageId': typeof AppsAppIdVillagesVillageIdRoute
  '/apps/$appId/users/': typeof AppsAppIdUsersIndexRoute
  '/apps/$appId/villages/': typeof AppsAppIdVillagesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bug-reports': typeof BugReportsRoute
  '/dashboard': typeof DashboardRoute
  '/dev': typeof DevRoute
  '/login': typeof LoginRoute
  '/logs': typeof LogsRoute
  '/profile': typeof ProfileRoute
  '/users': typeof UsersRoute
  '/apps': typeof AppsIndexRoute
  '/apps/$appId/errors': typeof AppsAppIdErrorsRoute
  '/apps/$appId/logs': typeof AppsAppIdLogsRoute
  '/apps/$appId/orders': typeof AppsAppIdOrdersRoute
  '/apps/$appId/payments': typeof AppsAppIdPaymentsRoute
  '/apps/$appId/products': typeof AppsAppIdProductsRoute
  '/apps/$appId': typeof AppsAppIdIndexRoute
  '/apps/$appId/villages/$villageId': typeof AppsAppIdVillagesVillageIdRoute
  '/apps/$appId/users': typeof AppsAppIdUsersIndexRoute
  '/apps/$appId/villages': typeof AppsAppIdVillagesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/apps': typeof AppsRouteWithChildren
  '/bug-reports': typeof BugReportsRoute
  '/dashboard': typeof DashboardRoute
  '/dev': typeof DevRoute
  '/login': typeof LoginRoute
  '/logs': typeof LogsRoute
  '/profile': typeof ProfileRoute
  '/users': typeof UsersRoute
  '/apps/$appId': typeof AppsAppIdRouteWithChildren
  '/apps/': typeof AppsIndexRoute
  '/apps/$appId/errors': typeof AppsAppIdErrorsRoute
  '/apps/$appId/logs': typeof AppsAppIdLogsRoute
  '/apps/$appId/orders': typeof AppsAppIdOrdersRoute
  '/apps/$appId/payments': typeof AppsAppIdPaymentsRoute
  '/apps/$appId/products': typeof AppsAppIdProductsRoute
  '/apps/$appId/users': typeof AppsAppIdUsersRouteWithChildren
  '/apps/$appId/villages': typeof AppsAppIdVillagesRouteWithChildren
  '/apps/$appId/': typeof AppsAppIdIndexRoute
  '/apps/$appId/villages/$villageId': typeof AppsAppIdVillagesVillageIdRoute
  '/apps/$appId/users/': typeof AppsAppIdUsersIndexRoute
  '/apps/$appId/villages/': typeof AppsAppIdVillagesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/apps'
    | '/bug-reports'
    | '/dashboard'
    | '/dev'
    | '/login'
    | '/logs'
    | '/profile'
    | '/users'
    | '/apps/$appId'
    | '/apps/'
    | '/apps/$appId/errors'
    | '/apps/$appId/logs'
    | '/apps/$appId/orders'
    | '/apps/$appId/payments'
    | '/apps/$appId/products'
    | '/apps/$appId/users'
    | '/apps/$appId/villages'
    | '/apps/$appId/'
    | '/apps/$appId/villages/$villageId'
    | '/apps/$appId/users/'
    | '/apps/$appId/villages/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bug-reports'
    | '/dashboard'
    | '/dev'
    | '/login'
    | '/logs'
    | '/profile'
    | '/users'
    | '/apps'
    | '/apps/$appId/errors'
    | '/apps/$appId/logs'
    | '/apps/$appId/orders'
    | '/apps/$appId/payments'
    | '/apps/$appId/products'
    | '/apps/$appId'
    | '/apps/$appId/villages/$villageId'
    | '/apps/$appId/users'
    | '/apps/$appId/villages'
  id:
    | '__root__'
    | '/'
    | '/apps'
    | '/bug-reports'
    | '/dashboard'
    | '/dev'
    | '/login'
    | '/logs'
    | '/profile'
    | '/users'
    | '/apps/$appId'
    | '/apps/'
    | '/apps/$appId/errors'
    | '/apps/$appId/logs'
    | '/apps/$appId/orders'
    | '/apps/$appId/payments'
    | '/apps/$appId/products'
    | '/apps/$appId/users'
    | '/apps/$appId/villages'
    | '/apps/$appId/'
    | '/apps/$appId/villages/$villageId'
    | '/apps/$appId/users/'
    | '/apps/$appId/villages/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppsRoute: typeof AppsRouteWithChildren
  BugReportsRoute: typeof BugReportsRoute
  DashboardRoute: typeof DashboardRoute
  DevRoute: typeof DevRoute
  LoginRoute: typeof LoginRoute
  LogsRoute: typeof LogsRoute
  ProfileRoute: typeof ProfileRoute
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logs': {
      id: '/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof LogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bug-reports': {
      id: '/bug-reports'
      path: '/bug-reports'
      fullPath: '/bug-reports'
      preLoaderRoute: typeof BugReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps': {
      id: '/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/': {
      id: '/apps/'
      path: '/'
      fullPath: '/apps/'
      preLoaderRoute: typeof AppsIndexRouteImport
      parentRoute: typeof AppsRoute
    }
    '/apps/$appId': {
      id: '/apps/$appId'
      path: '/$appId'
      fullPath: '/apps/$appId'
      preLoaderRoute: typeof AppsAppIdRouteImport
      parentRoute: typeof AppsRoute
    }
    '/apps/$appId/': {
      id: '/apps/$appId/'
      path: '/'
      fullPath: '/apps/$appId/'
      preLoaderRoute: typeof AppsAppIdIndexRouteImport
      parentRoute: typeof AppsAppIdRoute
    }
    '/apps/$appId/villages': {
      id: '/apps/$appId/villages'
      path: '/villages'
      fullPath: '/apps/$appId/villages'
      preLoaderRoute: typeof AppsAppIdVillagesRouteImport
      parentRoute: typeof AppsAppIdRoute
    }
    '/apps/$appId/users': {
      id: '/apps/$appId/users'
      path: '/users'
      fullPath: '/apps/$appId/users'
      preLoaderRoute: typeof AppsAppIdUsersRouteImport
      parentRoute: typeof AppsAppIdRoute
    }
    '/apps/$appId/products': {
      id: '/apps/$appId/products'
      path: '/products'
      fullPath: '/apps/$appId/products'
      preLoaderRoute: typeof AppsAppIdProductsRouteImport
      parentRoute: typeof AppsAppIdRoute
    }
    '/apps/$appId/payments': {
      id: '/apps/$appId/payments'
      path: '/payments'
      fullPath: '/apps/$appId/payments'
      preLoaderRoute: typeof AppsAppIdPaymentsRouteImport
      parentRoute: typeof AppsAppIdRoute
    }
    '/apps/$appId/orders': {
      id: '/apps/$appId/orders'
      path: '/orders'
      fullPath: '/apps/$appId/orders'
      preLoaderRoute: typeof AppsAppIdOrdersRouteImport
      parentRoute: typeof AppsAppIdRoute
    }
    '/apps/$appId/logs': {
      id: '/apps/$appId/logs'
      path: '/logs'
      fullPath: '/apps/$appId/logs'
      preLoaderRoute: typeof AppsAppIdLogsRouteImport
      parentRoute: typeof AppsAppIdRoute
    }
    '/apps/$appId/errors': {
      id: '/apps/$appId/errors'
      path: '/errors'
      fullPath: '/apps/$appId/errors'
      preLoaderRoute: typeof AppsAppIdErrorsRouteImport
      parentRoute: typeof AppsAppIdRoute
    }
    '/apps/$appId/villages/': {
      id: '/apps/$appId/villages/'
      path: '/'
      fullPath: '/apps/$appId/villages/'
      preLoaderRoute: typeof AppsAppIdVillagesIndexRouteImport
      parentRoute: typeof AppsAppIdVillagesRoute
    }
    '/apps/$appId/users/': {
      id: '/apps/$appId/users/'
      path: '/'
      fullPath: '/apps/$appId/users/'
      preLoaderRoute: typeof AppsAppIdUsersIndexRouteImport
      parentRoute: typeof AppsAppIdUsersRoute
    }
    '/apps/$appId/villages/$villageId': {
      id: '/apps/$appId/villages/$villageId'
      path: '/$villageId'
      fullPath: '/apps/$appId/villages/$villageId'
      preLoaderRoute: typeof AppsAppIdVillagesVillageIdRouteImport
      parentRoute: typeof AppsAppIdVillagesRoute
    }
  }
}

interface AppsAppIdUsersRouteChildren {
  AppsAppIdUsersIndexRoute: typeof AppsAppIdUsersIndexRoute
}

const AppsAppIdUsersRouteChildren: AppsAppIdUsersRouteChildren = {
  AppsAppIdUsersIndexRoute: AppsAppIdUsersIndexRoute,
}

const AppsAppIdUsersRouteWithChildren = AppsAppIdUsersRoute._addFileChildren(
  AppsAppIdUsersRouteChildren,
)

interface AppsAppIdVillagesRouteChildren {
  AppsAppIdVillagesVillageIdRoute: typeof AppsAppIdVillagesVillageIdRoute
  AppsAppIdVillagesIndexRoute: typeof AppsAppIdVillagesIndexRoute
}

const AppsAppIdVillagesRouteChildren: AppsAppIdVillagesRouteChildren = {
  AppsAppIdVillagesVillageIdRoute: AppsAppIdVillagesVillageIdRoute,
  AppsAppIdVillagesIndexRoute: AppsAppIdVillagesIndexRoute,
}

const AppsAppIdVillagesRouteWithChildren =
  AppsAppIdVillagesRoute._addFileChildren(AppsAppIdVillagesRouteChildren)

interface AppsAppIdRouteChildren {
  AppsAppIdErrorsRoute: typeof AppsAppIdErrorsRoute
  AppsAppIdLogsRoute: typeof AppsAppIdLogsRoute
  AppsAppIdOrdersRoute: typeof AppsAppIdOrdersRoute
  AppsAppIdPaymentsRoute: typeof AppsAppIdPaymentsRoute
  AppsAppIdProductsRoute: typeof AppsAppIdProductsRoute
  AppsAppIdUsersRoute: typeof AppsAppIdUsersRouteWithChildren
  AppsAppIdVillagesRoute: typeof AppsAppIdVillagesRouteWithChildren
  AppsAppIdIndexRoute: typeof AppsAppIdIndexRoute
}

const AppsAppIdRouteChildren: AppsAppIdRouteChildren = {
  AppsAppIdErrorsRoute: AppsAppIdErrorsRoute,
  AppsAppIdLogsRoute: AppsAppIdLogsRoute,
  AppsAppIdOrdersRoute: AppsAppIdOrdersRoute,
  AppsAppIdPaymentsRoute: AppsAppIdPaymentsRoute,
  AppsAppIdProductsRoute: AppsAppIdProductsRoute,
  AppsAppIdUsersRoute: AppsAppIdUsersRouteWithChildren,
  AppsAppIdVillagesRoute: AppsAppIdVillagesRouteWithChildren,
  AppsAppIdIndexRoute: AppsAppIdIndexRoute,
}

const AppsAppIdRouteWithChildren = AppsAppIdRoute._addFileChildren(
  AppsAppIdRouteChildren,
)

interface AppsRouteChildren {
  AppsAppIdRoute: typeof AppsAppIdRouteWithChildren
  AppsIndexRoute: typeof AppsIndexRoute
}

const AppsRouteChildren: AppsRouteChildren = {
  AppsAppIdRoute: AppsAppIdRouteWithChildren,
  AppsIndexRoute: AppsIndexRoute,
}

const AppsRouteWithChildren = AppsRoute._addFileChildren(AppsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppsRoute: AppsRouteWithChildren,
  BugReportsRoute: BugReportsRoute,
  DashboardRoute: DashboardRoute,
  DevRoute: DevRoute,
  LoginRoute: LoginRoute,
  LogsRoute: LogsRoute,
  ProfileRoute: ProfileRoute,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
